var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadPinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_439_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9993 17.4512H17.9991V10.1142H21.749L15.4992 4L9.24945 10.1142H12.9993V17.4512ZM27.1713 19.3246C26.9088 19.0506 25.1576 17.2176 24.6577 16.7395C24.3073 16.4109 23.8406 16.2277 23.3552 16.2283H21.159L24.9889 19.8895H20.5591C20.4989 19.8884 20.4394 19.9029 20.3868 19.9314C20.3341 19.96 20.29 20.0016 20.2591 20.0521L19.2391 22.3425H11.7594L10.7394 20.0521C10.7082 20.0018 10.6642 19.9603 10.6115 19.9318C10.5589 19.9032 10.4996 19.8887 10.4394 19.8895H6.00957L9.83818 16.2283H7.64326C7.14703 16.2283 6.67329 16.4228 6.3408 16.7395C5.84082 17.2188 4.08963 19.0519 3.82714 19.3246C3.21591 19.9616 2.87968 20.4691 3.03967 21.0964L3.7409 24.8554C3.90089 25.484 4.60461 26 5.30584 26H25.6951C26.3964 26 27.1001 25.484 27.2601 24.8554L27.9613 21.0964C28.1188 20.4691 27.7838 19.9616 27.1713 19.3246Z",
    fill: "#EF4840",
    fillOpacity: 0.68,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_439_26",
    x: 0,
    y: 0,
    width: 33,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_439_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_439_26",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPinkIcon);
export default __webpack_public_path__ + "static/media/upload-pink-icon.81720b9d2e25eb3d91ac2bf662f50341.svg";
export { ForwardRef as ReactComponent };